module.exports = __webpack_public_path__ + "img/star.586bd1f6.svg";